<template>
 <div class="slider-placeholder" :style="backgroundStyle">
     <!-- 
         The image is now set as a CSS background property 
         on the .slider-placeholder div via the :style binding below.
         We no longer use an <img> tag.
     -->
 </div>
</template>

<script>
import girl_long_hair from '../../assets/landing_p/salon_pics/girl_long_hair.jpg'
import salon_pic from '../../assets/landing_p/salon_pics/salon_pic.jpg'
import hair_wash from '../../assets/landing_p/salon_pics/woman-getting-her-hair-washed.jpg'
import girl from '../../assets/landing_p/salon_pics/just_a_girl.jpg'

import mobile_pic from '../../assets/landing_p/salon_pics/mobile_view_pic.jpg'

export default {
    name: 'SalonImgsSlider',
    data() {
        return {
           allDesktopImages: [
            { src: salon_pic, alt: 'Interior of the Salon'},
            { src: girl_long_hair, alt: 'Woman with long hair'},
            { src: hair_wash, alt: 'Woman getting her hair washed'},
            { src: girl, alt: 'Just a girl'}
            ],
           mobileImage: { src: mobile_pic, alt: 'Girl and makeup items'},
           slides: [],
           currentIndex: 0,
           sliderInterval: null,
           resizeTimeout: null,
        };
    },
    computed: {
        // Returns the currently active image object
        currentImage() {
            return this.slides[this.currentIndex] || {};
        },
        /**
         * Creates the inline style object to dynamically set the background image.
         */
        backgroundStyle() {
            return {
                backgroundImage: `url(${this.currentImage.src})`,
            };
        }
    },
    created() { 
        this.updateSlidesArray(); 
    },
    mounted() {
        this.startSlider();
        window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
        clearInterval(this.sliderInterval);
        window.removeEventListener('resize', this.handleResize);
        clearTimeout(this.resizeTimeout);
    },
    methods: {
        handleResize() {
            // Debounced call to prevent excessive array loading
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(this.updateSlidesArray, 200);
        },

        /**
         * Determine the correct set of images (desktop or mobile)
         * and reloads the slides array if necessary.
         */
        updateSlidesArray() {
            const isMobile = window.innerWidth <= 600;
            let newSlides;

            if (isMobile) {
                // Use only portrait image
                newSlides = [this.mobileImage]
            } else {
                // If desktop, use the array landscape images
                newSlides = this.allDesktopImages;
            }

            // Check if the slide set has actually changed
            if (this.slides.length === 0 || newSlides[0].src !== this.slides[0].src) {
                this.slides = newSlides; // clear current slides
                this.currentIndex = 0;
                this.manageSliderInterval();
            }

        },

        /**
         * Manages starting or stopping the slider based on the current slide count.
         */
        manageSliderInterval() {
            // 1. Always clear any existing interval first to prevent ghosts
            clearInterval(this.sliderInterval);
            this.sliderInterval = null;

            // 2. Only start a NEW interval if there is more than one image
            if (this.slides.length > 1) {
                this.sliderInterval = setInterval(() => {
                    // The main sliding logic
                    this.currentIndex = (this.currentIndex + 1) % this.slides.length; 
                }, 5000); // Change the image every 5 seconds
            }
        },

        startSlider() {
            this.manageSliderInterval(); // Just points to the new management method
        }
    }
}
</script>

<style scoped>
 /* Removed var() definitions as they should be in the parent file */
 .slider-placeholder {
            background-color: #f5f5f4; /* Fallback background color */
            height: 600px; /* Fixed height is necessary for parallax */
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            color: #5D0E1F;
            text-align: center;
            border-radius: 10px;
            margin-top: 2rem;
            box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
            overflow: hidden;
            width: 100%;
            
            /* Background properties for parallax effect */
            background-position: center;
            background-size: cover;
            /* ⭐ THE KEY PARALLAX PROPERTY ⭐ */
            background-attachment: fixed; 
            transition: background-image 0.9s ease-in-out; /* Smooth fade effect when image changes */
        }
 /* Removed .salon_img styles as the <img> tag is no longer used */

 @media (max-width: 600px) {
  .slider-placeholder {
    /* 1. Disable parallax to fix zoom issue */
    background-attachment: scroll; 
    
    /* 2. Fix the height. Padding-top: 133% can be erratic with background images.
       Using vh (viewport height) or a fixed px height is safer for background-cover */
    height: 500px; 
    padding-top: 0; /* Remove the padding-top if you had it */
    
    /* 3. contain ensures the whole image is seen, but 'cover' is usually 
       better for sliders as long as 'fixed' is turned off */
    background-size: cover; 
  }

}
</style>